export default {
  'Resolution': 'Разрешение',
  'Frame rate': 'Частота кадров',
  'The higher the frame rate, the smoother the animation': 'Чем выше частота кадров, тем плавнее анимация.',
}